import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globals } from '@anduin/config';
import { Observable } from 'rxjs';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  constructor(private readonly _globals: Globals) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // If the request URL starts with /api, prepend the artEngineApiUrl
    if (request.url.startsWith('/api')) {
      const apiUrl = `${this._globals.actionEngineUrl}${request.url}`;
      request = request.clone({ url: apiUrl });
    }

    return next.handle(request);
  }
}
